import { render, staticRenderFns } from "./SentEmailPanel.vue?vue&type=template&id=b90135be&scoped=true"
import script from "./SentEmailPanel.vue?vue&type=script&lang=js"
export * from "./SentEmailPanel.vue?vue&type=script&lang=js"
import style0 from "./SentEmailPanel.vue?vue&type=style&index=0&id=b90135be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90135be",
  null
  
)

export default component.exports